import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBudIconBorder = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800.7",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "b",
		"data-name": "Layer 1",
		children: [
			/* @__PURE__ */ _jsx("polygon", {
				points: "600 500.7 300 500.7 300 300.7 500 300.7 500 400.7 600 300.7 600 200.7 200 200.7 200 600.7 600 600.7 600 500.7",
				style: {
					isolation: "isolate",
					opacity: .5
				}
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 150,
				y: 150.7,
				width: 500,
				height: 500,
				style: { fill: "#fff" }
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 800.7,
				height: 800.7,
				style: { fill: "#fff" }
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		id: "c",
		"data-name": "Layer 2",
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "m50,50.7v700h700V50.7H50Zm600,600H150V150.7h500v500Z" }), /* @__PURE__ */ _jsx("path", { d: "m500,350.7v-70l-70-80h-230v400h400v-170l-70-80h-30Zm-200-50h100v50h-100v-50Zm0,200v-50h200v50h-200Z" })] }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "m50,50.7v700h700V50.7H50Zm600,600H150V150.7h500v500Z" }), /* @__PURE__ */ _jsx("path", { d: "m500,350.7v-70l-70-80h-230v400h400v-170l-70-80h-30Zm-200-50h100v50h-100v-50Zm0,200v-50h200v50h-200Z" })] })]
	})]
});
export default SvgBudIconBorder;
